import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import CheckoutErrorsFactory from '../Errors/factory.js'
import CheckoutMappersFactory from '../Mappers/factory.js'
import HTTPCheckoutRepository from './HTTPCheckoutRepository.js'

export default class CheckoutRepositoriesFactory {
  static hTTPCheckoutRepository = ({config}) =>
    new HTTPCheckoutRepository({
      config,
      authenticationFetcher: FetcherFactory.httpAuthenticationFetcher({config}),
      paymentMethodsCheckoutRawDataToPaymentMethodsCheckoutVOMapper:
        CheckoutMappersFactory.paymentMethodsCheckoutRawDataToPaymentMethodsCheckoutVOMapper({config}),
      orderRawDataToOrderEntityMapper: CheckoutMappersFactory.orderRawDataToOrderEntityMapper({config}),
      purchaseCheckoutRawDataToPurchaseCheckoutEntityMapper:
        CheckoutMappersFactory.purchaseCheckoutRawDataToPurchaseCheckoutEntityMapper({config}),
      getPaymentMethodsCheckoutError: CheckoutErrorsFactory.getPaymentMethodsCheckoutError,
      purchaseCheckoutError: CheckoutErrorsFactory.purchaseCheckoutError,
      purchaseDetailsCheckoutError: CheckoutErrorsFactory.purchaseDetailsCheckoutError
    })
}
